<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col>
        <h2>
          <v-icon class="mr-2">
            mdi-point-of-sale
          </v-icon>
          freee請求連携
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-expansion-panels
          accordion
        >
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>

                  <v-row>
                    <v-col cols="12" md="4">
                      <cs-date-picker
                        :date.sync="searchForms.billingMonth"
                        type="month"
                        @dateChangedCallback="billingMonthChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <v-text-field
                            v-model="searchForms.billingMonth"
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="errors"
                            append-icon="mdi-calendar"
                            clearable
                            dense
                            hide-details="auto"
                            label="請求月度"
                            outlined
                            rounded
                            persistent-hint
                            persistent-placeholder
                            readonly
                          />
                        </template>
                      </cs-date-picker>
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-checkbox
                        v-model="searchForms.errors"
                        label="エラーのみ検索"
                        dense
                        hide-details="auto"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="searchForms.keyword"
                        prepend-inner-icon="mdi-magnify"
                        background-color="white"
                        dense
                        hide-details="auto"
                        outlined
                        rounded
                        placeholder="エラー内容"
                        style="font-size: 80%"
                        clearable
                        @blur="searchButtonClickEvent"
                        @click:clear="searchForms.keyword = null; searchButtonClickEvent()"
                      />
                    </v-col>

                  </v-row>

                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click="searchButtonClickEvent"
                  >
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    &nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card flat>
          <v-data-table
            v-model="rowSelected"
            :headers="tableHeaders"
            :items="freee_billing_transactions"
            disable-pagination
            :items-per-page="-1"
            disable-sort
            hide-default-footer
            show-select
            checkbox-color="#DCDCDC"
          >

            <!-- ステータス -->
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                x-small
                label
                dark
                class="stretchedChip"
                :color="item.status | status_chip_freee_billing_transaction_color"
              >
                {{ item.status | status_to_label_freee_billing_transaction }}
              </v-chip>
            </template>
            <!-- ステータス -->

            <!-- 請求先 -->
            <template v-slot:[`item.billing_name`]="{ item }">
              <div
                :title="item.billing_name"
                class="line-clamp one-clamp"
              >
                {{ item.billing_name }}
              </div>
              {{ item.billing_output_at | unix_datetime_format }}
            </template>
            <!-- /請求先 -->

            <!-- 請求月度・請求対象期間 -->
            <template v-slot:[`item.billing_month`]="{ item }">
              <div>
                {{ item.billing_month }}
              </div>
              {{ item.billing_term }}
            </template>
            <!-- /請求月度・請求対象期間 -->

            <!-- 請求支払区分・請求予定金額 -->
            <template v-slot:[`item.billing_payment_type`]="{item}">
              <div
                v-if="item.billing_payment_type != null"
              >
                <v-chip
                  x-small
                  label
                  dark
                  :color="item.billing_payment_type | billing_payment_type_color"
                >
                  {{ item.billing_payment_type | billing_payment_type_label }}
                </v-chip>
              </div>
              <span v-if="item.plan_billing_amount != null" class="font-weight-black">
                {{ parseFloat(item.plan_billing_amount) | comma_format }}
              </span>
            </template>
            <!-- /請求支払区分・請求予定金額 -->
            <!-- フッター -->
            <template v-slot:footer>
              <v-card flat>
                <v-card-actions>
                  <v-spacer />
                  <template>
                    <v-btn
                      color="primary"
                      class="mr-3"
                      :disabled="rowSelected.length <= 0"
                      @click="freeeRequestButtonClickEvent"
                    >
                      再連携
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </template>
            <!-- /フッター -->

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import Confirm from '@/components/Confirm'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
  name: 'DriverSalesFreeeTransactions',
  components: {
    CustomPagination,
    Confirm
  },
  mixins: [
  ],
  props: {},
  data() {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      showTargetDatePicker: false,
      searchForms: {
        billingMonth: null,
        errors: null,
        keyword: null,
      },
      freee_billing_transactions: [],
      rowSelected: [],
      tableHeaders: [
        { text: '連携結果', value: 'status', width: '5%' },
        { text: '請求先\r\n連携日時', value: 'billing_name',align: 'center' , width: '20%'},
        { text: '締日/ｻｲﾄ/入金', value: 'billing_info', width: '15%' },
        { text: '請求月度\r\n請求対象期間', value: 'billing_month', width: '10%' },
        { text: '請求支払区分\r\n請求予定金額', value: 'billing_payment_type',align: 'center', width: '10%' },
        { text: 'エラー内容', value: 'transaction_results', width: '40%' },
      ],
    }
  },
  computed: {
    ...mapState('DriverSalesFreeeTransaction', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('DriverSalesFreeeTransaction', [
      'selectedMembers',
      'hasResult'
    ]),
  },
  watch: {},
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
      this.searchCondition.billing_month = this.$dayjs().format("YYYY-MM")
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.searchForms.billingMonth = this.searchCondition.billing_month
    this.searchForms.errors = this.searchCondition.errors
    this.searchForms.keyword = this.searchCondition.keyword
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit
    this.searchTransactions()
  },
  methods: {
    ...mapActions('DriverSalesFreeeTransaction', {
      fetchTransactions: 'index',
      transactionsRegister: 'create',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
    }),
    changePage(page) {
      this.page = page;
      this.searchTransactions()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchTransactions()
    },
    /**
     * 請求月度変更　コールバック
     */
    billingMonthChangedCallback (value) {
      this.searchForms.billingMonth = value;
      this.searchButtonClickEvent();
    },
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1
      this.searchTransactions()
    },
    searchTransactions () {
      this.rowSelected = null
      this.rowSelected = []
      let params = this.buildParam('json')
      this.fetchTransactions(params).then((content) => {
        this.freee_billing_transactions = content.freee_billing_transactions
      })
    },

    /**
     * 検索パラメータの生成
     * @param format
     * @return {{billing_id: null, supplier_type: null, format, page: number, keyword: null, supplier_id: null}}
     */
    buildParam (format) {
      return {
        page: this.page,

        billing_month: this.searchForms.billingMonth,
        errors: this.searchForms.errors,
        keyword: this.searchForms.keyword,

        limit: this.perPage,
        format: format
      }
    },
    /**
     * 再連携ボタン クリックイベント
     */
     freeeRequestButtonClickEvent () {
      this.selectedIds = this.rowSelected.map(v=>v.id)
      let modalOption = { title: '再連携', message: 'freeeに再連携します。\r\nよろしいですか？', options: { titleColor: 'blue' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          let params = { freee_billing_transactions_ids: this.selectedIds }
          this.transactionsRegister({params: params}).then(() => {
            this.rowSelected = null
            this.rowSelected = []
            this.searchTransactions()
          })
        }
      })
    },
  }
}
</script>


<style scoped lang="scss">

.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

</style>
